export const CONST_MESSAGE_DECENTRALIZATION ={
    decentralizationSuccessfully: 'Phân quyền thành công',
    actionFailed: 'Thao tác thất bại',
    deleteSuccessfully: 'Xóa thành công',
    deleteFailed: 'Xóa thất bại'
}